/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsClassificationsCount } from './JumboStructsClassificationsCount';
import {
    JumboStructsClassificationsCountFromJSON,
    JumboStructsClassificationsCountFromJSONTyped,
    JumboStructsClassificationsCountToJSON,
} from './JumboStructsClassificationsCount';

/**
 * 
 * @export
 * @interface JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult
 */
export interface JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult {
    /**
     * 
     * @type {JumboStructsClassificationsCount}
     * @memberof JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult
     */
    classificationCounts?: JumboStructsClassificationsCount;
    /**
     * 
     * @type {number}
     * @memberof JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult
     */
    needsActionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult
     */
    totalActiveThreats?: number;
}

/**
 * Check if a given object implements the JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult interface.
 */
export function instanceOfJumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResultFromJSON(json: any): JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult {
    return JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResultFromJSONTyped(json, false);
}

export function JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classificationCounts': !exists(json, 'classificationCounts') ? undefined : JumboStructsClassificationsCountFromJSON(json['classificationCounts']),
        'needsActionCount': !exists(json, 'needsActionCount') ? undefined : json['needsActionCount'],
        'totalActiveThreats': !exists(json, 'totalActiveThreats') ? undefined : json['totalActiveThreats'],
    };
}

export function JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResultToJSON(value?: JumboGetsentinelonethreatmetricsactiveActiveThreatMetricsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classificationCounts': JumboStructsClassificationsCountToJSON(value.classificationCounts),
        'needsActionCount': value.needsActionCount,
        'totalActiveThreats': value.totalActiveThreats,
    };
}

